"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _Spin = _interopRequireDefault(require("../Spin"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var checkBoxStyle = {
  marginRight: 8,
  marginTop: -1,
  verticalAlign: 'top'
};

var Node =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Node, _PureComponent);

  function Node(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      loading: false
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handlePathChange = _this.handlePathChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Node.prototype;

  _proto.checkDisabled = function checkDisabled() {
    var _this$props = this.props,
        datum = _this$props.datum,
        id = _this$props.id,
        disabled = _this$props.disabled;
    if (disabled) return true;
    return datum.isDisabled(id);
  };

  _proto.handleClick = function handleClick() {
    var _this$props2 = this.props,
        id = _this$props2.id,
        data = _this$props2.data,
        path = _this$props2.path,
        onChange = _this$props2.onChange,
        onPathChange = _this$props2.onPathChange,
        loader = _this$props2.loader,
        multiple = _this$props2.multiple,
        datum = _this$props2.datum;
    onPathChange(id, data, path);

    if (!multiple) {
      onChange([].concat(path, [id]), datum.getDataById(id));
    }

    if (loader && !this.state.loading) {
      this.setState({
        loading: true
      });
      loader(id, data);
    }
  };

  _proto.handlePathChange = function handlePathChange() {
    var _this$props3 = this.props,
        id = _this$props3.id,
        data = _this$props3.data,
        path = _this$props3.path,
        onPathChange = _this$props3.onPathChange; // if (active) return

    onPathChange(id, data, path);
  };

  _proto.handleChange = function handleChange(_, checked) {
    var _this$props4 = this.props,
        datum = _this$props4.datum,
        id = _this$props4.id,
        onChange = _this$props4.onChange;
    datum.set(id, checked ? 1 : 0);
    onChange(datum.getValue(), datum.getDataById(id));
  };

  _proto.renderContent = function renderContent() {
    var _this$props5 = this.props,
        id = _this$props5.id,
        active = _this$props5.active,
        data = _this$props5.data,
        renderItem = _this$props5.renderItem;
    var render = typeof renderItem === 'function' ? renderItem : function (d) {
      return d[renderItem];
    };
    return render(data, active, id);
  };

  _proto.render = function render() {
    var _this$props6 = this.props,
        active = _this$props6.active,
        data = _this$props6.data,
        multiple = _this$props6.multiple,
        datum = _this$props6.datum,
        id = _this$props6.id,
        loader = _this$props6.loader,
        expandTrigger = _this$props6.expandTrigger;
    var loading = this.state.loading;
    var disabled = this.checkDisabled();
    var className = (0, _styles.cascaderClass)('node', active && 'active', disabled && 'disabled', data.children && data.children.length > 0 && 'has-children', loader && !loading && data.children === undefined && 'may-be-children');
    var style = {};
    var events = {};

    if (!disabled && (expandTrigger !== 'hover-only' || !data.children || data.children.length === 0)) {
      events.onClick = this.handleClick;
      style.cursor = 'pointer';
    }

    if (expandTrigger === 'hover' || expandTrigger === 'hover-only') events.onMouseEnter = this.handlePathChange;
    return _react.default.createElement("div", _extends({
      className: className,
      style: style
    }, events), multiple && _react.default.createElement(_Checkbox.default, {
      checked: datum.getChecked(id),
      disabled: disabled,
      onChange: this.handleChange,
      style: checkBoxStyle
    }), this.renderContent(), loading && data.children === undefined && _react.default.createElement(_Spin.default, {
      className: (0, _styles.cascaderClass)('loading'),
      size: 10,
      name: "ring"
    }));
  };

  return Node;
}(_component.PureComponent);

Node.propTypes = {
  active: _propTypes.default.bool,
  data: _propTypes.default.object,
  datum: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  expandTrigger: _propTypes.default.string,
  id: _propTypes.default.string,
  loader: _propTypes.default.func,
  multiple: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onPathChange: _propTypes.default.func,
  path: _propTypes.default.array,
  renderItem: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]).isRequired
};
var _default = Node;
exports.default = _default;